// extracted by mini-css-extract-plugin
module.exports = {"container":"lazyloadImage_container__3F4pj","thumbnail":"lazyloadImage_thumbnail__2DheQ","img":"lazyloadImage_img__lg2gy"};